import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import appRoutes from "./routes";

/* Importing Views */
import Authentification from "@/views/authentification/Authentification";
import Register from "@/views/authentification/Register";
import FinishRegister from "@/views/authentification/FinishRegister";
import SLayout from "@/views/dashboard/SLayout";
import SensorCharts from "@/views/dashboard/SensorCharts";
import User from "@/views/dashboard/User";

Vue.use(VueRouter);

const APP_NAME = "Le Capteur Français";

let dashboardRoutes = [];

appRoutes.forEach((route) => {
  dashboardRoutes.push({
    path: route.route.path,
    name: route.route.name,
    component: route.route.component,
    meta: {
      title: `${route.title + " | " + APP_NAME}`,
      requiresAuth: true,
    },
  });
});

const routes = [
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      title: `Inscription | ${APP_NAME}`,
    },
  },
  {
    path: "/register/finish",
    name: "FinishRegister",
    component: FinishRegister,
    meta: {
      title: `Compléter l'inscription | ${APP_NAME}`,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Authentification,
    meta: {
      title: `Connexion | ${APP_NAME}`,
    },
  },
  {
    path: "",
    component: SLayout,
    children: [
      ...dashboardRoutes,
      {
        path: "/sensors/:sensorId",
        name: "SensorCharts",
        component: SensorCharts,
        meta: {
          title: `${"Capteur" + " | " + APP_NAME}`,
          requiresAuth: true,
        },
      },
      {
        path: "/users/:userId",
        name: "User",
        component: User,
        meta: {
          title: `${"Utilisateur" + " | " + APP_NAME}`,
          requiresAuth: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const requireAuth = to.matched.some((record) => record.meta.requiresAuth);

  const isAuthenticated = store.getters["auth/isLogged"];
  const user = store.getters["auth/getUser"];
  let isAdmin = false;

  if(user) {
    isAdmin = user.userType == 'ADMIN';
  }

  if (
    (to.name === "Login" ||
      to.name === "Register" ||
      to.name === "FinishRegister") &&
    isAuthenticated
  ) {
    return next({ name: "Home" });
  }

  if (requireAuth) {
    if (isAuthenticated) {
      switch (to.name) {
        case "Home": {
          next();
          break;
        }
        case "Sensors": {
          next();
          break;
        }
        case "SensorCharts": {
          next();
          break;
        }
        case "Users": {
          if (isAdmin) next();
          else next({ name: "Home" });
          break;
        }
        case "User": {
          next();
          break;
        }
      }
    } else next({ name: "Login" });
  } else next();
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title;
  });
});

export default router;
